<div
    class="d-flex w-100 h-100"
    [ngStyle]="{ backgroundColor: colors ? colors.mainColor : 'transparent' }"
>
    <div class="d-inline-flex justify-content-between align-items-center container w-100">
        <app-link [appRouterLink]="urlSegments" title="Homepage">
            <img [src]="pbsLogo" alt="PBS LearningMedia logo" />
            <div class="vertical-divider ms-3 me-4 bg-white"></div>
            <div class="collection-title">
                <img *ngIf="logo" [src]="logo" alt="{{ collectionTitle }} Logo" />
                <h5 *ngIf="!logo" class="collection-title text-white">
                    {{ collectionTitle }}
                </h5>
            </div>
        </app-link>
        <div class="d-flex align-items-center">
            <ng-container *ngIf="window.innerWidth > screenBreakpoints.Tablet">
                <div class="text-white me-4">Topic:</div>
                <div ngbDropdown class="d-inline-block me-4 p-2 border border-white rounded">
                    <div ngbDropdownToggle class="text-white position-relative text-truncate pe-3">
                        {{ selectedTopic ? selectedTopic.title : "Select topic" }}
                    </div>
                    <div ngbDropdownMenu aria-labelledby="collection-sections-navbar">
                        <div
                            ngbDropdownItem
                            class="selenium-topic-{{ topic.titleForAutoscroll }}"
                            *ngFor="let topic of topics"
                            (click)="scrollToTopic($event, topic)"
                        >
                            {{ topic.title }}
                        </div>
                    </div>
                </div>
            </ng-container>
            <app-search-collection-input
                *ngIf="window.innerWidth > screenBreakpoints.SmallDevice"
                [placeholder]="'Search ' + collectionTitle"
                [disableAutocomplete]="true"
                [collection]="collectionSlug"
            ></app-search-collection-input>
        </div>
    </div>
</div>
